@if (!useOnlyContent) {
  <div class="modal-header py-2 bg-light">
    <h6
      class="modal-title">{{ service.optionsImport.titleModal ? (service.optionsImport.titleModal | transloco) : 'Import' }}</h6>
    <button type="button" data-bs-dismiss="modal" (click)="activeModal.dismiss()" aria-label="Close" class="btn-close"></button>
  </div>
}

<div class="modal-body p-0"
     [class.bg-white]="useOnlyContent"
     *transloco="let t">
  <ul class="nav nav-tabs"
      [class.nav-tabs-highlight]="!useOnlyContent"
      [class.nav-tabs-underline]="useOnlyContent"
      [class.nav-justified]="useOnlyContent"
  >
    <li class="nav-item" (click)="activeTab = 'all'">
      <div class="nav-link cursor-pointer" [ngClass]="{ 'active': activeTab == 'all' }">
        {{ t('common.all') }}
        <span class="badge bg-secondary rounded-pill ms-2 fw-normal">
 {{
            (service.optsFile.totalSuccess + service.optsFile.totalError + service.optsFile.totalWarning) | formatNumber:{useZero: true}
          }}
 </span>
      </div>
    </li>
    <li class="nav-item" (click)="activeTab = 'success'">
      <div class="nav-link cursor-pointer" [ngClass]="{ 'active': activeTab == 'success' }">
        {{ t('common.success') }}
        <span class="badge bg-success rounded-pill ms-2 fw-normal">
 {{ service.optsFile.totalSuccess | formatNumber:{useZero: true} }}
 </span>
      </div>
    </li>
    <li class="nav-item" (click)="activeTab = 'error'">
      <div class="nav-link cursor-pointer" [ngClass]="{ 'active': activeTab == 'error' }">
        {{ t('common.error') }}
        <span class="badge bg-danger rounded-pill ms-2 fw-normal">
 {{ service.optsFile.totalError | formatNumber:{useZero: true} }}
 </span>
      </div>
    </li>
    <li class="nav-item" (click)="activeTab = 'warning'">
      <div class="nav-link cursor-pointer" [ngClass]="{ 'active': activeTab == 'warning' }">
        {{ t('common.warning') }}
        <span class="badge bg-warning rounded-pill ms-2 fw-normal">
 {{ service.optsFile.totalWarning | formatNumber:{useZero: true} }}
 </span>
      </div>
    </li>
  </ul>

  @if (!useOnlyContent) {
    <div class="process-area px-3 mt-3">
      <app-progress-bar
        [totalPages]="service.optsFile.paginator.totalRecord"
        [currentPage]="service.optsFile.paginator.totalImported"/>
    </div>
  }

  <div class="p-3 pt-0 mt-3" style="overflow-y: scroll; min-height: 20rem; max-height: 25rem">
    <app-c-table>
      <thead class="sticky-top bg-white">
      <tr>
        <th>{{ t('common.line') }}</th>
        <th>{{ t('common.status') }}</th>
        <th>{{ t('common.content') }}</th>
      </tr>
      </thead>
      @if (service.optsFile.rowsFlat) {
        <tbody>
          @for (item of service.optsFile.rowsFlat; track item) {
            @if (activeTab == 'all' || (activeTab && activeTab == item.type)) {
              <tr>
                <td style="border-right: none !important;">{{ item.line ? item.line : '' }}</td>
                <td style="border-right: none !important;"
                    [class]="item.type == 'success' ? 'text-success' : (item.type == 'error' ? 'text-danger' : 'text-warning')">
                  @if (item.type != 'error') {
                    {{ 'common.success' | transloco }}
                  } @else {
                    {{ ('common.error' | transloco) }}
                  }
                </td>
                <td style="border-left: none !important;"
                    [class]="item.type == 'success' ? 'text-success' : (item.type == 'error' ? 'text-danger' : 'text-warning')">
                  @if (item.type != 'error') {
                    @for (mess of item.messages; track mess) {
                      <p
                        [innerHTML]="mess == 1 ? ('common.success' | transloco) : mess"
                        class="mb-0"></p>
                    }
                  } @else {
                    @for (mess of item.messages; track mess) {
                      <p [innerHTML]="mess" class="mb-0"></p>
                    }
                  }
                </td>
              </tr>
            }
          }
        </tbody>
      }
    </app-c-table>
  </div>

  <div class="p-3 text-end">
    <button class="btn btn-success"
            [disabled]="!service.optsFile.finishImport"
            (click)="service.exportFileLogsImport()">
      <i class="ph ph-floppy-disk-back me-2"></i>
      {{ t('common.saveLogFile') }}
    </button>

    @if (useOnlyContent) {
      <button
        type="button" class="btn btn-light btn-sm text-nowrap ms-3 fw-semibold"
        (click)="activeModal.dismiss()">
        {{ t('common.close') }}
      </button>
    }
  </div>
</div>

